import React from 'react';
import { 
  FaFacebook, 
  FaTwitter, 
  FaLinkedin, 
  FaWhatsapp, 
  FaEnvelope,
  FaLink
} from 'react-icons/fa';
import './ShareButtons.css';

const ShareButtons = ({ title, url, description, type = 'job' }) => {
  const currentUrl = url || window.location.href;
  const shareText = type === 'blog' 
    ? `Check out this article: ${title}`
    : `Check out this job opportunity: ${title}`;
  const encodedUrl = encodeURIComponent(currentUrl);
  const encodedText = encodeURIComponent(shareText);
  const encodedDescription = encodeURIComponent(description || '');

  const shareLinks = {
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
    twitter: `https://twitter.com/intent/tweet?text=${encodedText}&url=${encodedUrl}`,
    linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`,
    whatsapp: `https://wa.me/?text=${encodedText}%20${encodedUrl}`,
    email: `mailto:?subject=${encodeURIComponent(title)}&body=${encodedText}%20${encodedUrl}`,
  };

  const handleShare = (platform) => {
    const width = 600;
    const height = 400;
    const left = (window.innerWidth - width) / 2;
    const top = (window.innerHeight - height) / 2;

    window.open(
      shareLinks[platform],
      'Share',
      `width=${width},height=${height},left=${left},top=${top}`
    );
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(currentUrl)
      .then(() => {
        // You can add a toast notification here
        alert('Link copied to clipboard!');
      })
      .catch(err => {
        console.error('Failed to copy link:', err);
      });
  };

  return (
    <div className="share-buttons">
      <button 
        className="share-button facebook"
        onClick={() => handleShare('facebook')}
        aria-label="Share on Facebook"
      >
        <FaFacebook />
        <span>Facebook</span>
      </button>

      <button 
        className="share-button twitter"
        onClick={() => handleShare('twitter')}
        aria-label="Share on Twitter"
      >
        <FaTwitter />
        <span>Twitter</span>
      </button>

      <button 
        className="share-button linkedin"
        onClick={() => handleShare('linkedin')}
        aria-label="Share on LinkedIn"
      >
        <FaLinkedin />
        <span>LinkedIn</span>
      </button>

      <button 
        className="share-button whatsapp"
        onClick={() => handleShare('whatsapp')}
        aria-label="Share on WhatsApp"
      >
        <FaWhatsapp />
        <span>WhatsApp</span>
      </button>

      <button 
        className="share-button email"
        onClick={() => handleShare('email')}
        aria-label="Share via Email"
      >
        <FaEnvelope />
        <span>Email</span>
      </button>

      <button 
        className="share-button copy-link"
        onClick={copyToClipboard}
        aria-label="Copy link"
      >
        <FaLink />
        <span>Copy Link</span>
      </button>
    </div>
  );
};

export default ShareButtons; 